const EN = {
    title: 'Payments',
    table: {
        title: 'Payment List',
        columns: {
            id: 'ID',
            idLink: 'Link N°',
            idPuntored: 'Puntored ID',
            dni: 'Seller INE',
            paymentMethod: 'Method',
            amount: 'Amount',
            installments: 'Installment',
            createdAt: 'Date',
            status: 'Status',
        },
        paymentMethod: {
            DEBIT: 'DC',
            CREDIT: 'CC',
            PREPAID: 'PC'
        },
        filter: {
            0: {
                0: 'AUTHORIZATION_IN_PROGRESS',
                1: 'AUTHORIZATION_SKIPPED',
                2: 'AUTHORIZED',
                3: 'CONFIRMATION_ERROR',
                4: 'CONFIRMED',
                5: 'DENIED',
                6: 'NEW',
                title: 'Status'
            },
            1: {
                0: 'Diamond',
                1: 'Sapphire',
                2: 'Gold',
                3: 'Silver',
                4: 'Bronze',
                title: 'Level'
            },
        },
    },
};

export default EN;
